import React from "react";
import { Typography, Box, useMediaQuery, useTheme } from "@mui/material";

interface LogoProps {
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ onClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Typography
      variant={isMobile ? "body1" : "h6"}
      component="div"
      sx={{
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
      }}
      {...(onClick && { onClick })}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          ml: "0px",
          mt: "3px",
          mr: "3px",
        }}
      >
        <img
          src="/icon-256x256.png"
          alt="logo"
          style={{ height: isMobile ? "21px" : "27px" }}
        />
      </Box>
      <span style={{ fontWeight: 500 }}>soft</span>
      <span style={{ fontWeight: 300 }}> cap</span>
    </Typography>
  );
};

export default Logo;
